<template>
	<div class="home">
		<header>
            <Header />
        </header>
		<main>
            <section class="pay-box">
                <div class="pay-box-container">
                    <div class="container-title">{{ this.resources.resourceName }}</div>
                    <div class="content-table">
                        <el-descriptions title="资源详细信息" :column="1" :labelStyle="{'font-size':'15px'}" :contentStyle="{'font-size':'13px'}">
                            <el-descriptions-item label="资源名称">{{ this.resources.resourceName }}</el-descriptions-item>
                            <el-descriptions-item label="地点">{{ this.resources.address }}</el-descriptions-item>
                            <el-descriptions-item label="CPU核心数">{{ this.resources.cpuCore }}核</el-descriptions-item>
                            
                            <el-descriptions-item label="硬盘容量">{{ this.resources.hardDisk }}GB</el-descriptions-item>
                            <el-descriptions-item label="内存容量">{{ this.resources.memoryCapacity }}GB</el-descriptions-item>
                            <el-descriptions-item label="型号">{{ this.resources.model }}</el-descriptions-item>
                            <el-descriptions-item v-if="this.resources.monthRent != null" label="月租金额">{{ this.resources.monthRent }}元/月</el-descriptions-item>
                            <el-descriptions-item v-else-if="this.resources.yearRent != null" label="年租金额">{{ this.resources.yearRent }}元/年</el-descriptions-item>
                            <el-descriptions-item label="组网">{{ this.resources.networking }}</el-descriptions-item>
                            <el-descriptions-item label="资源描述">{{ this.resources.resourceDesc }}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                </div>
            </section>
		</main>
		<!-- <footer><Footer /></footer> -->
	</div>
</template>

<script>
import Header from '../../components/header.vue';
// import Footer from '../../components/footer.vue';
export default {
  	name: 'Home',
	components: {
		Header,
		// Footer
	},
	data() {
		return {
			resources:JSON.parse(sessionStorage.getItem("resources")) || {},
            
		};
	},
	mounted() {
        console.log(this.resources);
	},
    methods:{
        
    }
}
</script>
<style lang="scss" scoped>
.home{
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    width:100%;
    height:100%;
    background-color: #f9fafb;
}
.pay-box{
    width:100%;
    height:auto;
    padding:50px 0 20px;
    background-color: #f9fafb;
    .pay-box-container{
        width:60%;
        height:500px;
        margin:0 auto;
        box-sizing:border-box;
        padding:20px 30px;
        background-color: #fff;
        display:flex;
        justify-content: center;
        align-items: center;
        .container-title{
            width:100%;
            font-size:18px;
            font-weight: 600;
            color:#000;
            margin-bottom:10px;
        }
        .content-table{
            width: 100%;
            height: 100%; 
            display: flex; 
            justify-content: center; 
            align-items: center; 
        }
    }
}
</style>

<style  scoped>
.handle-select{
    width:220px;
    margin-right:10px;
}
.handle-input{
    width:600px;
    margin-right:10px;
}
</style>
